import React from "react";
import ScrollDown from '../components/ScrollDown';
import Anime from "react-anime";
import PhaseFourAnimation from "../components/PhaseFourAnimation";
export default ({ isActive, goToNextSlide }) => {
  const fadeInTitle = {
    opacity: [
      { value: 0, duration: 0, },
      { value: 1, duration: 2500, easing: 'linear', delay: 2000}
    ]
  };

  const handleNextSlide = () => goToNextSlide();
  return (
    <div className="component">
      <PhaseFourAnimation isActive={isActive} />

      {isActive && (
          <Anime {...fadeInTitle}>
            <ScrollDown text={'Now Entering Phase 4'} onClickNextSlide={handleNextSlide} />
          </Anime>
        )}
    </div>
  );
};
